export class Queue {
  constructor() {
    this.items = [];
  }

  enqueue(item) {
    this.items.push(item);
  }

  dequeue() {
    if (this.isEmpty()) {
      return undefined;
    }

    return this.items.shift();
  }

  front() {
    if (this.isEmpty()) {
      return undefined;
    }

    return this.items[0];
  }

  isEmpty() {
    return this.items.length === 0;
  }

  count() {
    return this.items.length;
  }

  waitForItem() {
    return new Promise(resolve => {
      if (this.items.length > 0) {
        return resolve(this.front());
      }

      setInterval(() => {
        if (this.items.length > 0) {
          resolve(this.front());
        }
      }, 100);
    });
  }
}
